export const shopMonitorSliderTime = {
    default: 30000,
    LeadingTime: 300000
}


export const templateDocuments = {
    bonusLevels: '/templatefiles/Bonus_Levels_Template.csv',
    bonusLevelsFileName: 'Bonus_Levels_Template.csv',
    scoreboard: '/templatefiles/Organization_Scoreboard_Template.csv',
    scoreboardFileName: 'Organization_Scoreboard_Template.csv',
}
export const getVisibilityStatus = (visibility) => {
    switch (visibility) {
        case 0:
            return 'Active';
        case 2:
            return 'Inactive';
        case 3:
            return 'Sold';
        default:
            return '';
    }
}; 